import { render, staticRenderFns } from "./WelcomeBlock.vue?vue&type=template&id=181aa50d&scoped=true"
import script from "./WelcomeBlock.vue?vue&type=script&lang=js"
export * from "./WelcomeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181aa50d",
  null
  
)

export default component.exports